// Shared period helpers for Insights hub + all subpages.
// Extracted from src/pages/Insights.tsx so subroutes can produce the same
// default month range when hit cold (e.g. via deep link without ?from/?to).

function pad(n: number): string {
  return String(n).padStart(2, '0');
}

export function fmt(d: Date): string {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function startOfMonth(d: Date): Date {
  return new Date(d.getFullYear(), d.getMonth(), 1);
}

export function endOfMonth(d: Date): Date {
  return new Date(d.getFullYear(), d.getMonth() + 1, 0);
}

export function defaultRange(): { from: string; to: string; label: string } {
  const today = new Date();
  return {
    from: fmt(startOfMonth(today)),
    to: fmt(endOfMonth(today)),
    label: 'this_month',
  };
}
